function _typeof(obj) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (obj) { return typeof obj; } : function (obj) { return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }, _typeof(obj); }
function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }
function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); Object.defineProperty(Constructor, "prototype", { writable: false }); return Constructor; }
function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); Object.defineProperty(subClass, "prototype", { writable: false }); if (superClass) _setPrototypeOf(subClass, superClass); }
function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }
function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }
function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } else if (call !== void 0) { throw new TypeError("Derived constructors may only return object or undefined"); } return _assertThisInitialized(self); }
function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }
function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }
function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }
function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
import { PaymentSDKPlugin } from '@payment/payment-sdk';
var BasePlugin = /*#__PURE__*/function (_PaymentSDKPlugin) {
  _inherits(BasePlugin, _PaymentSDKPlugin);
  var _super = _createSuper(BasePlugin);
  // 插件本身的状态管理

  function BasePlugin() {
    var _this;
    var options = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
    _classCallCheck(this, BasePlugin);
    _this = _super.call(this, options);
    // 仅做数据的初始化
    _defineProperty(_assertThisInitialized(_this), "options", {});
    _this.options = options;
    return _this;
  }

  // 初始化后，渲染检查 /init 接口返回的 config，获取 paySession 后
  _createClass(BasePlugin, [{
    key: "validate",
    value:
    // 校验表单信息
    function validate() {
      return true;
    }

    // 补充在 paysession 中的信息，由 sdk extend
  }, {
    key: "extendPaySession",
    value: function extendPaySession() {
      return {};
    }

    /** 调用 confirm 接口前 */
  }, {
    key: "beforeConfirm",
    value: function beforeConfirm() {}

    /** 扩展 confirm 接口入参  */
  }, {
    key: "extendConfirmParams",
    value: function extendConfirmParams() {
      return {};
    }

    /** 调用 confirm 接口后 */
  }, {
    key: "afterConfirm",
    value: function afterConfirm() {}

    // 未支持的 nextAction.type 兜底，业务处理逻辑
  }, {
    key: "handlePayAction",
    value: function handlePayAction(nextAction) {}

    // 销毁插件
  }, {
    key: "destroy",
    value: function destroy(element) {}
  }]);
  return BasePlugin;
}(PaymentSDKPlugin);
_defineProperty(BasePlugin, "pluginName", void 0);
_defineProperty(BasePlugin, "info", void 0);
export default BasePlugin;